<template>
  <el-dialog
    class="deteleDialog"
    :title="title"
    :width="width"
    :visible.sync="showVisible"
    :close-on-click-modal="false"
    @close="cancelFn"
    :before-close="cancelFn"
    append-to-body
  >
    <slot></slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'EXDialog',
    props:{
        width: String,
        title:String,
        showVisible: Boolean
    },
    methods:{
        cancelFn(){
          this.$emit('close')
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/EXDialog/index.vue